import { loansRoutes } from './loansRoutes';
import { smeRoutes } from './smeRoutes';
import { cardsRoutes } from './cardsRoutes';
import { hrRoutes } from './hrRoutes';

/**
 * Объект частично совместим с объектом конфига роутера, но в данный момент **не поддерживаются вложенные пути**
 */
export const routes = [
    ...loansRoutes,
    ...smeRoutes,
    ...cardsRoutes,
    ...hrRoutes,
    {
        name: 'mainpage',
        path: '/',
        component: () => import(/* webpackChunkName: "mainpage" */ '/local/templates/redesign/src/pages/main.vue'),
    },
    {
        name: 'mainpage-ab',
        path: '/1/',
        component: () => import(/* webpackChunkName: "mainpage-ab" */ '/local/templates/redesign/src/pages/main-ab.vue'),
    },
    {
        name: 'deposits',
        path: '/(deposits|deposits1|deposits2)/:product?/:variant?/:variant?',
        component: () => import(/* webpackChunkName: "deposits" */ '/local/templates/redesign/src/pages/deposits.vue'),
    },
    {
        name: 'promoFriendPage',
        path: '/promo/friend/',
        component: () => import(/* webpackChunkName: "promoFriendPage" */ '/local/templates/redesign/src/pages/promo/promoFriendPage.vue'),
    },
    {
        name: 'promoClientPage',
        path: '/promo/client/',
        component: () => import(/* webpackChunkName: "promoClientPage" */ '/local/templates/redesign/src/pages/promo/promoClientPage.vue'),
    },
    {
        name: 'promoCode',
        path: '/promo/code/',
        component: () => import(/* webpackChunkName: "promoCode" */ '/local/templates/redesign/src/pages/promo/promoCode.vue'),
    },
    {
        name: 'promo',
        path: '/promo/:product(deposits|higher-rate|higher-rate-promocode|client|action-big-jackpot)/:variant?',
        component: () => import(/* webpackChunkName: "deposits" */ '/local/templates/redesign/src/pages/deposits.vue'),
    },
    {
        name: 'promo-code-n',
        path: '/promo/:product(code|code-01|code-02|code-03|code-by-manager)/',
        component: () => import(/* webpackChunkName: "promo-code-n" */ '/local/templates/redesign/src/pages/promoCodeN.vue'),
    },
    {
        name: 'premium',
        path: '/premium',
        component: () => import(/* webpackChunkName: "premium" */ '/local/templates/redesign/src/pages/premium/index.vue'),
    },
    {
        name: 'premium-travel',
        path: '/premium/travel',
        component: () => import(/* webpackChunkName: "premiumTravel" */ '/local/templates/redesign/src/pages/premium/travel.vue'),
    },
    {
        name: 'premium-arenda',
        path: '/premium/arenda',
        component: () => import(/* webpackChunkName: "premiumArenda" */ '/local/templates/redesign/src/pages/premium/arenda.vue'),
    },
    {
        name: 'premium',
        path: '/premium/:detail?',
        component: () => import(/* webpackChunkName: "premiumDetail" */ '/local/templates/redesign/src/pages/premium/detail.vue'),
    },
    {
        name: 'escrow',
        path: '/escrow/:action?',
        component: () => import(/* webpackChunkName: "escrow" */ '/local/templates/redesign/src/pages/escrow.vue'),
    },
    {
        name: 'mortgage',
        path: '/mortgage/:product?/:variant?',
        component: () => import(/* webpackChunkName: "mortgage" */ '/local/templates/redesign/src/pages/mortgage.vue'),
    },
    {
        name: 'extra-info',
        path: '/extra-info',
        component: () => import(/* webpackChunkName: "extraInfo" */ '/local/templates/redesign/src/pages/extraInfo.vue'),
    },
    {
        name: 'conversion',
        path: '/conversion/',
        component: () => import(/* webpackChunkName: "conversion" */ '/local/templates/redesign/src/pages/conversion.vue'),
    },
    {
        name: 'nps',
        path: '/nps/',
        component: () => import(/* webpackChunkName: "nps" */ '/local/templates/redesign/src/pages/nps.vue'),
    },
    {
        name: 'private-banking',
        path: '/private-banking',
        component: () => import(/* webpackChunkName: "privateBanking" */ '/local/templates/redesign/src/pages/private/privateBanking.vue'),
    },
    {
        name: 'private-savings-account',
        path: '/private-banking/savings-account',
        component: () => import(/* webpackChunkName: "privateSavingsAccount" */ '/local/templates/redesign/src/pages/private/privateSavingsAccount.vue'),
    },
    {
        name: 'promo-private-old',
        path: '/promo/pmef',
        component: () => import(/* webpackChunkName: "promoPrivateOld" */ '/local/templates/redesign/src/pages/promoPrivateOld.vue'),
    },
    {
        name: 'private-old',
        path: '/private-banking/travel',
        component: () => import(/* webpackChunkName: "privateOld" */ '/local/templates/redesign/src/pages/private/privateOld.vue'),
    },
    {
        name: 'savings-account-ultra',
        path: '/savings-account/ultra',
        component: () => import(/* webpackChunkName: "accountUltraPage" */ '/local/templates/redesign/src/pages/savings-account/accountUltraPage.vue'),
    },
    {
        name: 'tg',
        path: '/tg/',
        component: () => import(/* webpackChunkName: "tg" */ '/local/templates/redesign/src/pages/tg.vue'),
    },
    {
        name: 'about-corporate-style-page',
        path: '/about/corporate-style',
        component: () => import(/* webpackChunkName: "aboutCorporateStyle" */ '/local/templates/redesign/src/pages/aboutCorporateStyle.vue'),
    },
    {
        name: 'about-compliance-page',
        path: '/about/compliance',
        component: () => import(/* webpackChunkName: "aboutCompliance" */ '/local/templates/redesign/src/pages/aboutCompliance.vue'),
    },
    {
        name: 'about',
        path: '/about/:product?/:variant?',
        component: () => import(/* webpackChunkName: "about" */ '/local/templates/redesign/src/pages/about.vue'),
    },
    {
        name: 'investment-and-products',
        path: '/investment-and-products/:product?/',
        component: () => import(/* webpackChunkName: "investment-and-products" */ '/local/templates/redesign/src/pages/investmentAndProducts.vue'),
    },
    {
        name: 'financial',
        path: '/financial/',
        component: () => import(/* webpackChunkName: "financial" */ '/local/templates/redesign/src/pages/financial.vue'),
    },
    {
        name: 'qa',
        path: '/q&a/:child?',
        component: () => import(/* webpackChunkName: "qa" */ '/local/templates/redesign/src/pages/qa.vue'),
    },
    {
        name: 'annual-report',
        path: '/annual-report/:period?',
        component: () => import(/* webpackChunkName: "annual-report" */ '/local/templates/redesign/src/pages/annual-report.vue'),
    },
    {
        name: 'special-account-page',
        path: '/special-account',
        component: () => import(/* webpackChunkName: "specialAccount" */ '/local/templates/redesign/src/pages/specialAccount.vue'),
    },
    {
        name: 'corporate-tourism',
        path: '/corporate/tourism',
        component: () => import(/* webpackChunkName: "corporateTourismPage" */ '/local/templates/redesign/src/pages/corporate/corporateTourismPage.vue'),
    },
    {
        name: 'corporate',
        path: '/corporate/(.*)',
        component: () => import(/* webpackChunkName: "corporate" */ '/local/templates/redesign/src/pages/corporate/corporate.vue'),
    },
    {
        name: 'for-developers-rko',
        path: '/for-developers/rko',
        component: () => import(/* webpackChunkName: "forDevelopersRkoPage" */ '/local/templates/redesign/src/pages/forDevelopersRkoPage.vue'),
    },
    {
        name: 'for-developers-rko-self',
        path: '/for-developers/rko/self-regulatory',
        component: () => import(/* webpackChunkName: "forDevelopersRkoSelfPage" */ '/local/templates/redesign/src/pages/forDevelopersRkoSelfPage.vue'),
    },
    {
        name: 'for-developers-rko-self',
        path: '/for-developers/bank-support',
        component: () => import(/* webpackChunkName: "forDevelopersBankSupport" */ '/local/templates/redesign/src/pages/forDevelopersBankSupport.vue'),
    },
    {
        name: 'for-developers-rko-self',
        path: '/for-developers/bank-support/docs',
        component: () => import(/* webpackChunkName: "forDevelopersBankSupportDocs" */ '/local/templates/redesign/src/pages/forDevelopersBankSupportDocs.vue'),
    },
    {
        name: 'for-developers-escrow',
        path: '/for-developers/escrow',
        component: () => import(/* webpackChunkName: "forDevelopersEscrow" */ '/local/templates/redesign/src/pages/forDevelopersEscrow.vue'),
    },
    {
        name: 'safe-boxes',
        path: '/safe-boxes/',
        component: () => import(/* webpackChunkName: "safeBoxes" */ '/local/templates/redesign/src/pages/safeBoxes.vue'),
    },
    {
        name: 'pay-loans',
        path: '/pay/loans/',
        component: () => import(/* webpackChunkName: "pay-loans" */ '/local/templates/redesign/src/pages/pay/loans.vue'),
    },
    {
        name: 'me2me',
        path: '/pay/me2me/',
        component: () => import(/* webpackChunkName: "me2me" */ '/local/templates/redesign/src/pages/pay/me2me.vue'),
    },
    {
        name: 'mobile-bank',
        path: '/mobile-bank/(.*)',
        component: () => import(/* webpackChunkName: "mobileBank" */ '/local/templates/redesign/src/pages/mobileBank.vue'),
    },
    {
        name: 'sbp',
        path: '/pay/sbp/',
        component: () => import(/* webpackChunkName: "paySbp" */ '/local/templates/redesign/src/pages/pay/sbp.vue'),
    },
    {
        name: 'become-investor',
        path: '/become-investor',
        component: () => import(/* webpackChunkName: "becomeInvestorPage" */ '/local/templates/redesign/src/pages/becomeInvestorPage.vue'),
    },
    {
        name: 'biometria',
        path: '/biometria/',
        component: () => import(/* webpackChunkName: "biometria" */ '/local/templates/redesign/src/pages/biometria.vue'),
    },
    {
        name: 'callback',
        path: '/callback/',
        component: () => import(/* webpackChunkName: "callback" */ '/local/templates/redesign/src/pages/callback.vue'),
    },
    {
        name: 'service-call',
        path: '/service/call/',
        component: () => import(/* webpackChunkName: "serviceCall" */ '/local/templates/redesign/src/pages/serviceCall.vue'),
    },
    {
        name: 'custody',
        path: '/custody/',
        component: () => import(/* webpackChunkName: "custody" */ '/local/templates/redesign/src/pages/custody.vue'),
    },
    {
        name: 'blog',
        path: '/(blog|faq)/:product?/:variant?',
        component: () => import(/* webpackChunkName: "blog" */ '/local/templates/redesign/src/pages/blog.vue'),
    },
    {
        name: 'promojackpot',
        path: '/promo/action-big-jackpot-client/',
        component: () => import(/* webpackChunkName: "promojackpot" */ '/local/templates/redesign/src/pages/promojackpot.vue'),
    },
    {
        name: 'settlement',
        path: '/settlement-account-escrow/',
        component: () => import(/* webpackChunkName: "escrow" */ '/local/templates/redesign/src/pages/escrow.vue'),
    },
    {
        name: 'pay',
        path: '/pay/:product?/:variant?',
        component: () => import(/* webpackChunkName: "pay" */ '/local/templates/redesign/src/pages/pay.vue'),
    },
    {
        name: 'akkreditiv',
        path: '/akkreditiv/',
        component: () => import(/* webpackChunkName: "akkreditiv" */ '/local/templates/redesign/src/pages/akkreditiv/akkreditiv.vue'),
    },
    {
        name: 'akkreditiv-form',
        path: '/akkreditiv/form/',
        component: () => import(/* webpackChunkName: "akkreditivForm" */ '/local/templates/redesign/src/pages/akkreditiv/akkreditivForm.vue'),
    },
    {
        name: 'for-sale',
        path: '/for-sale/:product?/:variant?',
        component: () => import(/* webpackChunkName: "for-sale" */ '/local/templates/redesign/src/pages/forSale.vue'),
    },
    {
        name: 'next',
        path: '/next/',
        component: () => import(/* webpackChunkName: "next" */ '/local/templates/redesign/src/pages/next.vue'),
    },
    {
        name: 'feedback',
        path: '/feedback/',
        component: () => import(/* webpackChunkName: "feedback" */ '/local/templates/redesign/src/pages/feedback.vue'),
    },
    {
        name: 'feedback-dbo',
        path: '/feedback-dbo/',
        component: () => import(/* webpackChunkName: "feedback-dbo" */ '/local/templates/redesign/src/pages/feedbackDbo.vue'),
    },
    {
        name: 'tutorial',
        path: '/tutorial/',
        component: () => import(/* webpackChunkName: "tutorial" */ '/local/templates/redesign/src/pages/tutorial.vue'),
    },
    {
        name: 'location-webview',
        path: '/location/mobile-app',
        component: () => import(/* webpackChunkName: "location-webview" */ '/local/templates/redesign/src/pages/location/webview.vue'),
    },
    {
        name: 'location',
        path: '/location/:city?',
        component: () => import(/* webpackChunkName: "location" */ '/local/templates/redesign/src/pages/location/index.vue'),
    },
    {
        name: 'pin',
        path: '/pin/',
        component: () => import(/* webpackChunkName: "pin" */ '/local/templates/redesign/src/pages/pin.vue'),
    },
    {
        name: 'press',
        path: '/press/:product?/:variant?',
        component: () => import(/* webpackChunkName: "press" */ '/local/templates/redesign/src/pages/press.vue'),
    },
    {
        name: 'docs',
        path: '/docs/',
        component: () => import(/* webpackChunkName: "docs" */ '/local/templates/redesign/src/pages/docs.vue'),
    },
    {
        name: 'insurance',
        path: '/insurance/',
        component: () => import(/* webpackChunkName: "insurance" */ '/local/templates/redesign/src/pages/insurance.vue'),
    },
    {
        name: 'actions',
        path: '/actions/:product?/',
        component: () => import(/* webpackChunkName: "actions" */ '/local/templates/redesign/src/pages/actions.vue'),
    },
    {
        name: 'mir',
        path: '/partners/mir/',
        component: () => import(/* webpackChunkName: "mir" */ '/local/templates/redesign/src/pages/mir.vue'),
    },
    {
        name: 'payroll',
        path: '/payroll/',
        component: () => import(/* webpackChunkName: "payroll" */ '/local/templates/redesign/src/pages/payroll.vue'),
    },
    {
        name: 'stock-market',
        path: '/stock-market/',
        component: () => import(/* webpackChunkName: "stock-market" */ '/local/templates/redesign/src/pages/stockMarket.vue'),
    },
    {
        name: 'contactCenter',
        path: '/contact-center/',
        component: () => import(/* webpackChunkName: "contactCenter" */ '/local/templates/redesign/src/pages/contactCenter.vue'),
    },
    {
        name: 'egrn',
        path: '/egrn/(.*)',
        component: () => import(/* webpackChunkName: "egrn" */ '/local/templates/redesign/src/pages/egrn.vue'),
    },
    {
        name: 'eng-cn',
        path: '/(eng|cn)',
        component: () => import(/* webpackChunkName: "eng-cn" */ '/local/templates/redesign/src/pages/engCnPage.vue'),
    },
    {
        name: 'verify-email',
        path: '/verify/email',
        component: () => import(/* webpackChunkName: "verify-email" */ '/local/templates/redesign/src/pages/verifyEmailPage.vue'),
    },
    {
        name: 'nazprombank',
        path: '/insurance-companies/nazcorpbank/',
        component: () => import(/* webpackChunkName: "nazprombank" */ '/local/templates/redesign/src/pages/nazprombank.vue'),
    },
    {
        name: 'reviews',
        path: '/reviews/',
        component: () => import(/* webpackChunkName: "reviews" */ '/local/templates/redesign/src/pages/reviews.vue'),
    },
    {
        name: 'prolongation',
        path: '/prolongation-insurance/',
        component: () => import(/* webpackChunkName: "prolongation" */ '/local/templates/redesign/src/pages/prolongationInsurance.vue'),
    },
    {
        name: 'anti-fraud',
        path: '/anti-fraud/',
        component: () => import(/* webpackChunkName: "anti-fraud" */ '/local/templates/redesign/src/pages/antiFraud.vue'),
    },
    {
        name: 'esia',
        path: '/esia-update/(.*)',
        component: () => import(/* webpackChunkName: "esia" */ '/local/templates/redesign/src/pages/esiaUpdate.vue'),
    },
    {
        name: 'partner',
        path: '/partner/',
        component: () => import(/* webpackChunkName: "partner" */ '/local/templates/redesign/src/pages/partner.vue'),
    },
    {
        name: 'update-dbo',
        path: '/dbo-update/(.*)',
        component: () => import(/* webpackChunkName: "update-dbo" */ '/local/templates/redesign/src/pages/updateDbo.vue'),
    },
    {
        name: 'personal-policy',
        path: '/personal-policy/',
        component: () => import(/* webpackChunkName: "personal-policy" */ '/local/templates/redesign/src/pages/personalPolicy.vue'),
    },
    {
        name: 'mobile-banker-calling',
        path: '/mobile-banker-calling/',
        component: () => import(/* webpackChunkName: "mobile-banker-calling" */ '/local/templates/redesign/src/pages/mobileBankerCalling.vue'),
    },
    {
        name: 'ios',
        path: '/ios/',
        component: () => import(/* webpackChunkName: "ios" */ '/local/templates/redesign/src/pages/ios.vue'),
    }
];
